module.exports = __webpack_public_path__ + "img/Care3Mobile.7c2350e0.png";